import empityGas from '../../assets/empity_gas.svg';
import gas01 from '../../assets/gas_01.svg';
import gas02 from '../../assets/gas_02.svg';
import gas03 from '../../assets/gas_03.svg';
import gas04 from '../../assets/gas_04.svg';
import gas05 from '../../assets/gas_05.svg';

export function getImageGasLevel(gasLevel: number): string {
  if (gasLevel === 0) {
    return empityGas;
  }
  if (gasLevel <= 20) {
    return gas01;
  }
  if (gasLevel <= 40) {
    return gas02;
  }
  if (gasLevel <= 60) {
    return gas03;
  }
  if (gasLevel <= 70) {
    return gas04;
  }
  return gas05;
}
